// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import type { ArticleType } from 'types/Article';
import Label from 'components/fragments/text/Label';
import { nullLoadingArticle } from 'types/Article';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import { Link } from 'react-router-dom';
import { getDateFromString, formatFullDate } from 'utils/dateUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';

type Props = {
  content: ArticleType,
  small?: boolean,
  containerStyle?: string
};

class BillBoardCard extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    content: nullLoadingArticle,
    small: false,
    containerStyle: '',
  };

  renderMatch = () => {
    const {
      content: {
        rencontre_liee,
        rencontre_details,
      },
      content,
    } = this.props;

    if (content && rencontre_liee && rencontre_details) {
      const {
        localStructure: { nom: localNom, embleme: localEmbleme },
        visiteurStructure: { nom: visiteurNom, embleme: visiteurEmbleme },
        pointsStructureLocale,
        pointsStructureVisiteur,
      } = rencontre_details || { localStructure: {}, visiteurStructure: {} };

      const localWon = (pointsStructureLocale > pointsStructureVisiteur && 'ft-700') || '';
      const visiteurWon = (pointsStructureVisiteur > pointsStructureLocale && 'ft-700') || '';
      return (
        <div className="match box">
          <div className="match__club">
            <p className={localWon}>
              <span>
                {localNom}
              </span>
              <img src={localEmbleme} alt={`Logo ${localNom}`} width="24" height="24"/>
            </p>
          </div>
          <div className="match__info">
            <p className="match__score">
              <span className={localWon}>{pointsStructureLocale}</span>
              <span className="match__colon">-</span>
              <span className={visiteurWon}>{pointsStructureVisiteur}</span>
            </p>
          </div>
          <div className="match__club">
            <p className={visiteurWon}>
              <img src={visiteurEmbleme} alt={`Logo ${visiteurNom}`} width="24" height="24" />
              <span>
                {visiteurNom}
              </span>
            </p>
          </div>
        </div>
      );
    }

    return  null;
  };

  render() {
    const {
      content: {
        date: contentDate,
        title,
        slug,
        label,
        illustration,
        srcset,
        rencontre_liee,
      },
      small,
      containerStyle
    } = this.props;

    const classNamesCardContainer = dynamicClassName('box card card--billboard inset-score');
    const date = formatFullDate(getDateFromString(contentDate));

    small && classNamesCardContainer.add('is-small-desktop');
    containerStyle && classNamesCardContainer.add(containerStyle);

    return (
      <Link
        title={`Lire la suite de l'article : ${title}`}
        to={`/actualites/${label.slug}/${slug}`}
        className={classNamesCardContainer.build()}
        onClick={handleTagEvent('module_actualite', title, '')}>
        <div className="card--billboard__content box">
          <BackgroundImage
            className="card__thumbnail img-blue"
            illustration={illustration}
            srcset={srcset}
          />
          <div className="card__body">
            <p className="card__date ft-h6">{date}</p>
            <h3 className="card__title ft-h2">{title}</h3>
          </div>
          <div className="card__footer">
            <span className="btn btn--dark">
              <i className="icon icon-chevron-right link-icon is-dark is-inline" />
              <span>Lire la suite</span>
            </span>
          </div>
          <div className="card__type">
            <Label label={label.name} />
          </div>
          {rencontre_liee && this.renderMatch()}
        </div>
      </Link>
    );
  }
}

export default BillBoardCard;
